export default __webpack_public_path__ + "static/media/vim4.4cb1a212.svg";